import { defineComponent as d, computed as o, openBlock as c, createElementBlock as i, createElementVNode as t, toDisplayString as n, createCommentVNode as v, normalizeStyle as f } from "vue";
const h = ["viewBox"], _ = /* @__PURE__ */ t("mask", { id: "84fcdfe2-458d-4d52-a5d5-8dd487b2c743" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#84fcdfe2-458d-4d52-a5d5-8dd487b2c743)" }, u = { key: 0 }, k = /* @__PURE__ */ t("path", {
  fill: "#eee",
  d: "M0 0h512v512H0Z"
}, null, -1), p = /* @__PURE__ */ t("path", {
  fill: "#333",
  d: "M131 189v78c0 12-10 22-22 22v34c30 0 55-25 55-56v-78zm50 0v45a39 39 0 0 0 39 39 39 39 0 0 0 22-7 39 39 0 0 0 22 7l5-1a22 22 0 0 1-21 17v34c30 0 55-25 55-56v-78h-33v45a6 6 0 0 1-11 0v-45h-34v45a6 6 0 0 1-11 0v-45zm139 0v78h33v-78zm50 0v78c0 12-10 22-22 22v34c31 0 56-25 56-56v-78ZM181 289v34h50v-34z"
}, null, -1), g = { fill: "none" }, x = ["r"], W = /* @__PURE__ */ d({
  __name: "af-emirate",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const e = r, l = o(() => 512 + 2 * e.strokeWidth), s = o(() => -e.strokeWidth), a = o(() => 256 + e.strokeWidth / 2);
    return (w, y) => (c(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      _,
      t("g", m, [
        e.flagName ? (c(), i("title", u, n(e.flagName), 1)) : v("", !0),
        k,
        p
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: a.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, h));
  }
});
export {
  W as default
};
//# sourceMappingURL=af-emirate-8e648119.js.map
